module.exports = __webpack_public_path__ + "media/images/procedure_managements/mobile_preview-c73a4260a75049f3688c21bc954eb5bc.png";